<script setup>
import { useLoaderStore } from '@/stores/loader'

const loader = useLoaderStore()
</script>

<template>
  <!--Data Loader-->
  <div
    v-if="loader.visible"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 z-50 lg:absolute lg:inset-0"
  >
    <pv-progress-spinner
      style="width: 50px; height: 50px"
      strokeWidth="6"
    />
  </div>
  <!--End of Data Loader-->
  <!-- <div
    v-if="loader.visible"
    class="absolute inset-0 z-50 bg-white/70 dark:bg-black/50 flex items-center justify-center"
  >
    <pv-progress-spinner
      style="width: 50px; height: 50px"
      strokeWidth="8"
    />
  </div> -->
</template>
